module.exports = __webpack_public_path__ + "img/prize-03-pic.7678a3da.png";